import { data } from '../../svg/StepOver/data';
import { makeIcon } from '../makeIcon';

export const StepOver = makeIcon(data, 'step_over', 'StepOver');

export default StepOver;
